/* Arctic Elegance — product page: variants, gallery, zoom, sticky bar, recommendations */
(function () {
  'use strict';

  var theme = window.theme || {};
  var strings = theme.strings || {};

  function initProduct(section) {
    if (section.dataset.initialised) return;
    section.dataset.initialised = 'true';

    var jsonEl = section.querySelector('[data-product-json]');
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var picker = section.querySelector('[data-variant-picker]');
    var idInput = section.querySelector('[data-variant-id]');
    var addButton = section.querySelector('[data-add-button]');
    var addLabel = section.querySelector('[data-add-label]');
    var priceWrap = section.querySelector('[data-product-price]');
    var sticky = section.querySelector('[data-sticky-buy]');
    var gallery = section.querySelector('[data-gallery]');

    /* ---------- Gallery ---------- */
    var viewport = gallery && gallery.querySelector('[data-gallery-viewport]');
    var thumbs = gallery ? gallery.querySelectorAll('[data-thumb-for]') : [];
    var dots = gallery ? gallery.querySelectorAll('[data-dot-for]') : [];

    function setActiveMedia(mediaId) {
      thumbs.forEach(function (t) {
        if (t.getAttribute('data-thumb-for') === String(mediaId)) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
      dots.forEach(function (d) { d.classList.toggle('is-active', d.getAttribute('data-dot-for') === String(mediaId)); });
    }

    function showMedia(mediaId, smooth) {
      if (!viewport || !mediaId) return;
      var slide = viewport.querySelector('[data-media-id="' + mediaId + '"]');
      if (!slide) return;
      var isSlider = viewport.scrollWidth > viewport.clientWidth + 2;
      if (isSlider) {
        viewport.scrollTo({ left: slide.offsetLeft - viewport.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      } else if (smooth) {
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      setActiveMedia(mediaId);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showMedia(thumb.getAttribute('data-thumb-for'), true); });
    });

    if (viewport && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) setActiveMedia(entry.target.getAttribute('data-media-id'));
        });
      }, { root: null, threshold: [0.6] });
      viewport.querySelectorAll('[data-media-id]').forEach(function (s) { observer.observe(s); });
    }

    if (gallery) {
      var zoomDialog = gallery.querySelector('[data-zoom-dialog]');
      var zoomImage = gallery.querySelector('[data-zoom-image]');
      gallery.addEventListener('click', function (event) {
        var zoom = event.target.closest('[data-zoom-src]');
        if (!zoom || !zoomDialog) return;
        zoomImage.src = zoom.getAttribute('data-zoom-src');
        zoomImage.alt = zoom.getAttribute('data-zoom-alt') || '';
        theme.openDialog(zoomDialog, zoom);
      });
      if (zoomDialog) zoomDialog.addEventListener('click', function (event) {
        if (event.target === zoomImage) theme.closeDialog(zoomDialog);
      });
    }

    /* ---------- Variants ---------- */
    if (!product || !picker) {
      initSticky();
      return;
    }

    var fieldsets = picker.querySelectorAll('[data-option-index]');

    function selectedOptions() {
      var values = [];
      fieldsets.forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        values.push(checked ? checked.value : null);
      });
      return values;
    }

    function findVariant(options) {
      return product.variants.find(function (v) {
        return v.options.every(function (value, i) { return value === options[i]; });
      });
    }

    function updateAvailability(options) {
      fieldsets.forEach(function (fs, index) {
        fs.querySelectorAll('input').forEach(function (input) {
          var candidate = options.slice();
          candidate[index] = input.value;
          var match = product.variants.some(function (v) {
            return v.available && v.options.every(function (value, i) { return value === candidate[i]; });
          });
          var label = fs.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !match);
        });
        var selectedLabel = fs.querySelector('[data-selected-value]');
        if (selectedLabel) selectedLabel.textContent = options[index] || '';
      });
    }

    function updatePrice(variant) {
      if (!priceWrap || !theme.formatMoney) return;
      var price = priceWrap.querySelector('[data-price]');
      var current = priceWrap.querySelector('[data-price-current]');
      var compare = priceWrap.querySelector('[data-price-compare]');
      if (current) current.textContent = theme.formatMoney(variant.price);
      var onSale = variant.compare_at_price > variant.price;
      if (compare) {
        compare.hidden = !onSale;
        compare.textContent = onSale ? theme.formatMoney(variant.compare_at_price) : '';
      }
      if (price) price.classList.toggle('price--sale', onSale);
    }

    function updateButtons(variant) {
      var available = variant && variant.available;
      var label = !variant ? strings.unavailable : (available ? strings.addToBag : strings.soldOut);
      if (addButton) addButton.disabled = !available;
      if (addLabel) addLabel.textContent = label;
      if (sticky) {
        var stickyButton = sticky.querySelector('[data-sticky-add]');
        if (stickyButton) { stickyButton.disabled = !available; stickyButton.textContent = label; }
        var stickyVariant = sticky.querySelector('[data-sticky-variant]');
        if (stickyVariant && variant) stickyVariant.textContent = variant.title;
        var stickyPrice = sticky.querySelector('[data-sticky-price]');
        if (stickyPrice && variant && theme.formatMoney) stickyPrice.textContent = theme.formatMoney(variant.price);
      }
    }

    function onChange() {
      var options = selectedOptions();
      var variant = findVariant(options);
      updateAvailability(options);
      updateButtons(variant);
      var error = section.querySelector('[data-form-error]');
      if (!variant) {
        if (error) { error.textContent = strings.variantUnavailable; error.hidden = false; }
        return;
      }
      if (error) error.hidden = true;
      if (idInput) idInput.value = variant.id;
      updatePrice(variant);
      if (variant.featured_media_id) showMedia(variant.featured_media_id, true);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      section.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: variant } }));
    }

    picker.addEventListener('change', function (event) {
      if (event.target.matches('[data-option-input]')) onChange();
    });
    updateAvailability(selectedOptions());

    initSticky();

    /* ---------- Sticky mobile bar ---------- */
    function initSticky() {
      var buy = section.querySelector('[data-buy-buttons]');
      if (!sticky || !buy || !('IntersectionObserver' in window)) return;
      sticky.hidden = false;
      var stickyButton = sticky.querySelector('[data-sticky-add]');
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', passed);
        sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
        if (stickyButton) stickyButton.tabIndex = passed ? 0 : -1;
      }).observe(buy);
    }
  }

  /* ---------- Recommendations ---------- */
  function loadRecommendations(container) {
    if (container.dataset.loaded) return;
    container.dataset.loaded = 'true';
    fetch(container.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) {
          container.innerHTML = fresh.innerHTML;
          if (theme.syncWishlistButtons) theme.syncWishlistButtons(container);
        }
      })
      .catch(function () {});
  }

  function init(root) {
    (root || document).querySelectorAll('[data-product-section]').forEach(initProduct);
    var recs = (root || document).querySelectorAll('[data-recommendations]');
    if (!recs.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { loadRecommendations(entry.target); obs.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px 400px 0px' });
      recs.forEach(function (r) { io.observe(r); });
    } else {
      recs.forEach(loadRecommendations);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }, { once: true });
  else init();

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
